module.exports = __webpack_public_path__ + "static/media/FleetLocate_LoginBanners_Flex2.d6be77e4.jpg";